import { useTranslation } from 'react-i18next';

import ButtonDemo from '../button';
import { FeaturesCard } from './components/FeatureCard';
import style from './style.module.scss';

import mobileIcon from '../../../assets/icons/mobile.svg';
import cryptoIcon from '../../../assets/icons/shits.svg';
import supportIcon from '../../../assets/icons/support.svg';
import SectionTitle from '../sectionTitle';

export function Features() {
    const { t } = useTranslation();

    const icons = [mobileIcon, cryptoIcon, supportIcon];
    const cards = t('features.cards', { returnObjects: true });

    return (
        <section id='features' className={`section ${style["features"]}`}>
            <div className={`container ${style["features__container"]}`}>
                <SectionTitle
                    label={t('features.label')}
                    title={t('features.title')}
                />

                <div className={style["features__cards"]}>
                    {cards.map((item, i) => (
                        <FeaturesCard
                            key={i}
                            title={item.title}
                            subtitle={item.subtitle}
                            icon={icons[i]}
                        />
                    ))}
                </div>
            </div>

            <div className={`container section ${style["features__footer"]}`}>
                <h2>
                    {t('features.footer.before')}
                    <br />
                    <span className='accent'>
                        {t('features.footer.accent')}
                    </span>
                </h2>

                <ButtonDemo
                    size='large'
                    directIcon
                >
                    {t('button.titleBook')}
                </ButtonDemo>
            </div>
        </section>
    );
}